import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { AppShell } from '../components/layout/AppShell';
import { EmptyState } from '../components/ui';
import { AuthLayout } from './AuthLayout';

const TITLE = 'Nothing brewing here';
const DESCRIPTION =
  'The page you were looking for does not exist, or it moved while you were away.';

/**
 * Whatever address this was, it is not one.
 *
 * Two things Phase 28 changed. It said the same thing twice — "Nothing brewing
 * here" above "Page not found" — which is one sentence of brand voice paying
 * for itself and a second one repeating it. And it put a **signed-in** reader
 * into the signed-out layout, so somebody who mistyped a story id lost the whole
 * product and was offered the front door as their way back. Signed in, this is
 * now the product with an empty page in it; signed out, it is still the doorway.
 */
export function NotFoundPage() {
  const { account } = useAuth();
  const navigate = useNavigate();

  if (account) {
    return (
      <AppShell>
        <EmptyState
          title={TITLE}
          description={DESCRIPTION}
          actionLabel="Find something to read"
          onAction={() => navigate('/discover')}
        />
      </AppShell>
    );
  }

  return (
    <AuthLayout
      title={TITLE}
      subtitle={DESCRIPTION}
      footer={<Link to="/">Back to the home page</Link>}
    />
  );
}
